// @flow

import React from 'react'
import Appear from './Appear'
import { markdown } from 'markdown'

type Props = {
  title: string,
}

const Communications1 = ({ title }: Props) => {
  return (
    <Appear>
      <div className="">
        {title && <div className="mb-4 text-xl font-bold leading-tight text-left md:mb-4 text-green" dangerouslySetInnerHTML={{ __html: markdown.toHTML(title) }} />}
      </div>
    </Appear>
  )
}

export default Communications1
